import React from 'react';
import { CheckCircle, ArrowRight } from 'lucide-react';
import SEO from '../../components/common/SEO';
import { buildCanonicalUrl } from '../../utils/seoUtils';

const CustomAgentPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="Request Demo"
        description="Request a personalized demo of our enterprise accelerators. See ready-to-deploy solutions in action and get a tailored implementation timeline for your business."
        canonicalUrl={buildCanonicalUrl('/custom')}
        keywords="request demo, enterprise accelerators, custom solutions, day 1 impact"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Request Demo</h1>
          <p className="text-xl text-gray-600">
            Use our accelerators and get Day 1 impact. Ready-to-deploy solutions customized for your business needs.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Why Our Accelerators?</h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Get Day 1 impact with ready-to-go solutions</span>
                </li>
                <li className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Seamless integration with your existing systems</span>
                </li>
                <li className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Industry-specific compliance and security</span>
                </li>
                <li className="flex items-start space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
                  <span>Go live in weeks, not months</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold mb-4">How It Works</h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="bg-primary-100 text-primary-600 rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold">1</div>
                  <div>
                    <div className="font-medium">Demo Ready-to-Go Solution</div>
                    <div className="text-sm text-gray-500">We showcase our accelerator in action with your use case</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-primary-100 text-primary-600 rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold">2</div>
                  <div>
                    <div className="font-medium">Understand Your Requirements</div>
                    <div className="text-sm text-gray-500">Deep dive into your specific business needs and constraints</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-primary-100 text-primary-600 rounded-full w-6 h-6 flex items-center justify-center text-sm font-semibold">3</div>
                  <div>
                    <div className="font-medium">Customize & Go Live</div>
                    <div className="text-sm text-gray-500">Tailor the solution to your needs and deploy in weeks</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-primary-50 rounded-lg p-6 text-center">
            <h3 className="text-xl font-semibold text-primary-900 mb-2">Ready to See It in Action?</h3>
            <p className="text-primary-700 mb-6">
              Request a personalized demo of our accelerator solutions. 
              We'll show you exactly how it works for your use case and provide implementation timeline.
            </p>
            <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
              <a
                href="mailto:contact@kadellabs.com"
                className="bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors inline-flex items-center justify-center space-x-2"
              >
                <span>Request Demo</span>
                <ArrowRight className="h-4 w-4" />
              </a>
              <a
                href="mailto:contact@kadellabs.com"
                className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors inline-flex items-center justify-center space-x-2"
              >
                <span>📧</span>
                <span>contact@kadellabs.com</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomAgentPage;